import React from "react";
import Navbar1 from "./Navbar1";
import MainHeader from './MainHeader';


const Layout = () => (
        <React.Fragment>
            <Navbar1 />
            <MainHeader/>
        </React.Fragment>
        
);

export default Layout;
